import ItemType from 'client/util/Constants/ItemType';
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import Util from 'client/util/Util';

export default {
  data() {
    return {
      resultsMainActionText: 'go to users page',
    };
  },

  methods: {
    handleCancel() {
      ModalEventBus.close();
    },

    handleMainActionSuccess() {
      const systemUserItem = new ItemType.SystemUserItemType();
      Util.redirect(`${systemUserItem.route}?sort=-created`);
      this.handleCancel();
    },

    getDisclaimer(sourceName = '<application name>') {
      return `Remember that these users must be members of a user group bound to ${sourceName} for JumpCloud to manage their identity and/or access to ${sourceName}.`;
    },
  },
};
